var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container d-flex content align-items-center"},[_c('div',{staticClass:"bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"},[_c('bookmarks')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }